export const PASSWORD_RESET_REQUEST_REQUEST = 'PASSWORD_RESET_REQUEST_REQUEST'
export const PASSWORD_RESET_REQUEST_SUCCESS = 'PASSWORD_RESET_REQUEST_SUCCESS'
export const PASSWORD_RESET_REQUEST_FAIL = 'PASSWORD_RESET_REQUEST_FAIL'
export const PASSWORD_RESET_REQUEST_RESET = 'PASSWORD_RESET_REQUEST_RESET'

export const PASSWORD_RESET_CONFIRM_REQUEST = 'PASSWORD_RESET_CONFIRM_REQUEST'
export const PASSWORD_RESET_CONFIRM_SUCCESS = 'PASSWORD_RESET_CONFIRM_SUCCESS'
export const PASSWORD_RESET_CONFIRM_FAIL = 'PASSWORD_RESET_CONFIRM_FAIL'
export const PASSWORD_RESET_CONFIRM_RESET = 'PASSWORD_RESET_CONFIRM_RESET'
